import { Component, Input } from '@angular/core';

@Component({
  selector: 'fcp-pages-inc',
  templateUrl: './pages-inc.component.html',
  styleUrls: ['./pages-inc.component.scss']
})
export class PagesIncComponent {

  public page: any;

  @Input() public isVideo: boolean;
  @Input() set src(page: any) {
    page.urlIframe = page.urlIframe && (page.urlIframe.includes('http://') || page.urlIframe.includes('https://')) ? page.urlIframe : '';
    this.page = page;
  }

  get src(): any {
    return this.page;
  }

  public resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.body.scrollHeight + 400 + 'px';
  }

}
